import * as C from "@sp-crm/core";
import { rootRegionParentId } from "@sp-crm/core";
import {
    buildRegionTree,
    flattenTree,
} from "components/ui/region-visibility-tree/tree-utils";
import { produce } from "immer";
import { Action } from "redux";
import { Actions } from "../actions";
import { ChangeRegionAction } from "../actions/region";

export interface RegionState {
    selectedRegion: string;
    regions: C.TenantRegion[];
    explicitRegionSelected: boolean;
}

export function regionReducer(originalState: RegionState, action: Action): RegionState {
    if (!originalState) {
        originalState = {
            selectedRegion: null,
            regions: [],
            explicitRegionSelected: false,
        };
    }
    return produce(originalState, state => {
        if (action.type === Actions[Actions.LOGOUT]) {
            state.regions = [];
        }
        if (action.type === Actions[Actions.LOAD_TENANT_FINISH]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            const loadedTenant = C.Tenant.fromDocument((action as any).tenant);
            state.regions = loadedTenant.regions || [];
            if (
                state.selectedRegion &&
                !state.regions.find(r => r.key === state.selectedRegion)
            ) {
                state.selectedRegion = null;
                state.explicitRegionSelected = false;
            }
        }

        if (action.type === Actions[Actions.SELECT_REGION]) {
            const castAction = action as ChangeRegionAction;
            state.selectedRegion = castAction.selectedRegion;
            state.explicitRegionSelected = true;
        }

        if (!state.selectedRegion && state.regions.length > 0) {
            state.selectedRegion = selectDefaultRegion(state.regions);
        }
    });
}

export function selectDefaultRegion(regions: C.TenantRegion[]): string | null {
    if (regions.length === 0) {
        return null;
    }

    const tree = buildRegionTree(regions);
    const nodes = flattenTree(tree).filter(
        n => n.region.parentRegionId !== rootRegionParentId,
    );

    if (nodes.length === 0) {
        return null;
    }

    const minDepth = Math.min(...nodes.map(n => n.depth));
    const shallowest = nodes
        .filter(n => n.depth === minDepth)
        .sort((a, b) => a.region.name.localeCompare(b.region.name));

    const memberNodes = shallowest.filter(
        n => n.region.membershipType === C.EntityRegionPermissionType.Member,
    );

    if (memberNodes.length > 0) {
        return memberNodes[0].region.key;
    }

    return shallowest[0].region.key;
}
